<div class="modal-header">
    <h4 class="col-11 modal-title" id="myModalLabel">
        <img alt="Brand" src="{{directoryImages}}/assets/images/dhl-official2.png">
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div>
    <div class="modal-body">
        <div class="col-12">
            {{'Shared.Reference' | translate}}: <b>{{this.sesion.numeroExpedicionBuscado}}</b>
        </div>
        <mat-list>
            <ng-container *ngFor="let bulto of bultos">
                <mat-list-item (click)="sesion.searchExpedition(bulto.Identificador); this.modal.hide();"
                    style="cursor: pointer;">
                    <a matListItemTitle class="opcionTitle fw-bold">{{bulto.Identificador}}</a>
                    <div matListItemMeta><i class="bi bi-chevron-right opcionTitle"></i></div>
                    <div matListItemLine [ngClass]="{'color-gray-30': bulto.Status == ShipmentDetailStatus.Returned}"
                        class="fw-bold color-dark-green">{{textoStatus(bulto)}}</div>
                    <div matListItemLine class="d-flex row">
                        <div class="col-2 w-auto">{{bulto.Origin}}</div>
                        <i class="bi bi-arrow-right col-1"></i>
                        <div class="col-2 w-auto">{{bulto.Destination}}</div>
                    </div>
                </mat-list-item>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-list>
    </div>
</div>